<script lang="ts">
    import { navigate } from "svelte-routing"
    export let site: Site
    import Image from "./image.svelte"
    export let index
</script>

<main class="teaser">
    {#if index % 2 == 0 || window.innerWidth < 1023}
        <Image siteId="{site?.id}" siteImages="{site?.teaserImages}" />
    {/if}
    <div class="content">
        <h3>{site?.teaserTitle}</h3>
        <p>{site?.teaserDescription}</p>
        <button on:click="{() => navigate(site.path)}">MEHR</button>
    </div>
    {#if index % 2 == 1 && window.innerWidth > 1023}
        <Image siteId="{site?.id}" siteImages="{site?.teaserImages}" />
    {/if}
</main>

<style lang="less">
    @import "../../assets/css/variables.less";
    .teaser {
        max-width: @body-small-maxwidth;
        display: flex;
        flex-direction: column;
        gap: 2vw;
        width: 100%;
        @media @desktop {
            flex-direction: row;
        }
        div {
            flex: 1;
        }
        .content {
            flex: 1;
            display: flex;
            flex-direction: column;
            h3 {
                font-size: 2rem;
                font-weight: bold;
                margin: 0rem 0 1.6rem 0;
                color: @heading-font-color;
            }
            button {
                font-weight: bold;
                color: @link-font-color;
                width: fit-content;
                border-top: 3px solid @link-font-color;
                margin-top: 3rem;
            }
        }
    }
</style>
